// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { createContext } from "react";

export const LoadingContext = createContext();
